import { CompleteMenu } from '../components/CompleteMenu';

export const Menu = ():JSX.Element => {
  return (
    <CompleteMenu />
  );
}
